import { InjectionToken } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export class ModalRef<R = unknown> {
  private readonly subject = new Subject<R | undefined>();

  readonly closed: Observable<R | undefined> = this.subject.asObservable();

  close(result: R): void {
    this.subject.next(result);
    this.subject.complete();
  }

  dismiss(): void {
    this.subject.next(undefined);
    this.subject.complete();
  }
}

export const MODAL_REF = new InjectionToken<ModalRef>('MODAL_REF');
export const MODAL_DATA = new InjectionToken<unknown>('MODAL_DATA');
